export default '/pricing/free-trial-mobile';
